import { parsePhoneNumberFromString } from 'libphonenumber-js';

const stringUtils = {
  isEmptyString(value: string): boolean {
    return value ? value.trim().length === 0 : true;
  },
  capitalize(string: string): string {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  },
  pluralize(string: string, count: number): string {
    if (string.length === 0) return '';
    return count === 1 ? string : `${string}s`;
  },
  getFormattedPhoneNumber(phone: string): string {
    const parsedPhoneNumber = parsePhoneNumberFromString(phone, { defaultCallingCode: '1' });
    return parsedPhoneNumber?.formatNational() || '';
  },
  truncateString(string: string, numberOfCharactersToShow: number): string {
    if (string.length === 0) return '';
    return `${string.substring(0, numberOfCharactersToShow)}...`;
  },
};

export default stringUtils;
